import { Document, Code, DocumentPdf, Image, ZipReference, DataTable } from '@carbon/icons-react';
import type { CarbonIconType } from '@carbon/icons-react';
import { isAllowedFileType as validateFileTypeInternal } from '@sharpe/shared/attachments';

export function getFileTypeIcon(mediaType: string): CarbonIconType {
  if (mediaType.startsWith('image/')) {
    return Image;
  }

  if (mediaType === 'application/pdf') {
    return DocumentPdf;
  }

  if (
    mediaType === 'application/vnd.ms-excel' ||
    mediaType === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
    mediaType === 'text/csv'
  ) {
    return DataTable;
  }

  if (
    mediaType.startsWith('text/') ||
    mediaType === 'application/json' ||
    mediaType.includes('code')
  ) {
    return Code;
  }

  if (mediaType.includes('zip') || mediaType.includes('compressed')) {
    return ZipReference;
  }

  return Document;
}

export function formatFileSize(bytes: number): string {
  if (bytes === 0) return '0 B';

  const k = 1024;
  const sizes = ['B', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(1))} ${sizes[i]}`;
}

export function isImageType(mediaType: string): boolean {
  return mediaType.startsWith('image/');
}

export function isPdfType(mediaType: string): boolean {
  return mediaType === 'application/pdf';
}

export function isTextType(mediaType: string): boolean {
  return mediaType.startsWith('text/');
}

export function validateFileType(file: File): boolean {
  return validateFileTypeInternal(file.type);
}
